import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import './KeyMoments.scss';

function KeyMomentsImmersiveHeader({ onClose }) {
  const { formatMessage } = useIntl();

  return (
    <header className="dtv-web-c-key-moments-immersive-header">
      <div className="dtv-web-c-key-moments-immersive-header__shade" aria-hidden />
      <div className="dtv-web-c-key-moments-immersive-header__bar">
        <h2 className="dtv-web-c-key-moments-immersive-header__title">
          {formatMessage({
            id: 'keyMoments.immersive.title',
            defaultMessage: 'Highlights',
          })}
        </h2>
        <button
          type="button"
          className="dtv-web-c-key-moments-immersive-header__close"
          aria-label={formatMessage({
            id: 'keyMoments.immersive.closeAria',
            defaultMessage: 'Close highlights',
          })}
          onClick={onClose}
        >
          <span className="dtv-details-icons-icon dtv-icon-white-close" aria-hidden />
        </button>
      </div>
    </header>
  );
}

KeyMomentsImmersiveHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default React.memo(KeyMomentsImmersiveHeader);
